import { useApprovals } from "./approval-context";
import { useT } from "../i18n/index";

// A visible signal that an action is parked awaiting a second-person approval —
// the four-eyes flow made legible (ADR 0015 §6). Renders nothing when idle.
export function PendingApprovalBanner() {
  const { pending } = useApprovals();
  const { t } = useT();
  if (!pending) return null;
  return (
    <div role="status" className="banner banner-pending">
      <strong>{t("fourEyes.pending")}</strong> — <span>{pending.action}</span>
    </div>
  );
}
